import request from '@/router/axios';
export const add = (row) => {
    return request({
        url: '/api/produce/arrival-notice/insert',
        method: 'post',
        data: row
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/arrival-notice/update',
        method: 'post',
        data: row
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/arrival-notice/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
export const getList = (params) => {
    return request({
        url: '/api/produce/arrival-notice/select/page',
        method: 'get',
        params
    })
}
export const exportExcel = (params) => {
    return request({
        url: '/api/produce/arrival-notice/export',
        method: 'get',
        params,
        responseType: 'blob'
    })
}
export const remove = (ids) => {
    return request({
        url: '/api/produce/arrival-notice/delete/ids',
        method: 'get',
        params: {
            ids
        }
    })
}

